import { defineStore } from "pinia";

export const useEvaluationSkillCandidateStore = defineStore('evaluationSkillCandidate', {
    state: () => ({
        evaluationSkillCandidate: {},
        evaluationSkillCandidates: [],
    }),
    actions: {
        setEvaluationSkillCandidate(evaluationSkillCandidate) {
            this.evaluationSkillCandidate = evaluationSkillCandidate
        },
        setEvaluationSkillCandidates(evaluationSkillCandidates) {
            this.evaluationSkillCandidates = evaluationSkillCandidates
        },
        addEvaluationSkillCandidate(evaluationSkillCandidate) {
            this.evaluationSkillCandidates.unshift(evaluationSkillCandidate)
        },
        updateEvaluationSkillCandidate(evaluationSkillCandidate) {
            let index = this.evaluationSkillCandidates.findIndex(cl => cl.id === evaluationSkillCandidate.id)
            this.evaluationSkillCandidates.splice(index, 1, evaluationSkillCandidate)
        },
        deleteEvaluationSkillCandidate(evaluationSkillCandidate) {
            let index = this.evaluationSkillCandidates.findIndex(cl => cl.id === evaluationSkillCandidate.id)
            this.evaluationSkillCandidates.splice(index, 1)
        },
    },
});